import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admin-card-vouchers.loaders';
import { converters } from './admin-card-vouchers.converters';
import { AdminCardVouchersFilters } from './admin-card-vouchers.types';

export const adminCardVouchersKeys = queryKeyFactory('admin-card-vouchers');

export const useAdminCardVouchers = (
  cardId: string,
  filters: Partial<AdminCardVouchersFilters> = {},
) => {
  return useQuery({
    queryKey: adminCardVouchersKeys.list(filters),
    queryFn: () => loaders.getCardVouchers({ cardId, filters }),
    select: converters.getCardVouchers,
    enabled: !!cardId,
  });
};

export const useAdminCardVoucher = (voucherId: string) => {
  return useQuery({
    queryKey: adminCardVouchersKeys.detail(voucherId),
    queryFn: () => loaders.getCardVoucher({ voucherId }),
    select: converters.getCardVoucher,
    enabled: !!voucherId,
  });
};
